import React from "react";
import { connect } from "react-redux";
import "rc-slider/assets/index.css";
import { Input, Row, Col, Label } from "reactstrap";
import { formActions } from "../../../../../../store/actions/cms/form/form.action";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import { deepClone } from "../../../../../../helpers/objectHelper";
import { AlignmentButtonGroup } from "../../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import ListExpansion from "../../../../../../components/UI/ListExpansion/ListExpansion";
import EditorSlider from "../../../../../components/editor/tools/EditorSlider";

class InvoiceFieldSettings extends React.Component {
  handleChange = (color, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = color ? this.parseColorToRgba(color) : val;

    if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.props.dispatch(formActions.updateFormElement(element));
  };
  handleSelectOnChange = (opt, path) => {
    const names = path.split(".");
    let selectedElement = deepClone(this.props.selectedElement);
    if (path === 'data.invoiceCountries') {
      const countryList = Array.from(selectedElement[names[0]][names[1]]);
      countryList.push(opt);
      selectedElement[names[0]][names[1]] = countryList;
    } else if (path === 'data.defaultCountry') {
      selectedElement[names[0]][names[1]] = opt.value;
    }
    this.props.dispatch(formActions.updateFormElement(selectedElement));
  }
  expandArea = area => {
    this.setState({ [area]: !this.state[area] });
  };
  handleSpaceOnChange = (e, path, dir) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    const spaceValue = element[names[0]][names[1]];
    let value = e.target.value;
    let splitted = spaceValue.toString().split(" ");
    if (splitted.length > 1) {
      splitted[dir] = value + "px";
      splitted = splitted.join(" ");
      element[names[0]][names[1]] = splitted;
    } else {
      let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
      newString = newString.split(" ");
      newString[dir] = value + "px";

      element[names[0]][names[1]] = newString.join(" ");
    }
    this.props.dispatch(formActions.updateFormElement(element));
  };
  convertSpaceValue = (value, index) => {
    let splitted = value.toString().split(" ");
    if (splitted.length > 1) {
      return parseInt(splitted[index]);
    } else {
      return parseInt(splitted[0]);
    }
  };
  render() {
    const { selectedElement } = this.props;
    return (
      <div >

        <ListExpansion
          footer={false}
          icon="fa fa-square"
          description="InvoiceFieldStyle"
        >
          <AlignmentButtonGroup
            onChange={this.handleChange}
            alignment={selectedElement.data.labelAlign}
            path="data.labelAlign"
            type={["left", 'center', 'right']}
          />
          <br />
          {selectedElement.data.padding !== undefined ? (
            <React.Fragment>
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    <SystemLabel name="Padding" />
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col className="list-setting-item-title" style={{ display: 'inline-flex' }}>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={e => this.handleSpaceOnChange(e, `data.padding`, 0)}
                      value={this.convertSpaceValue(selectedElement.data.padding, 0)} />
                    <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Top" /></p></em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={e => this.handleSpaceOnChange(e, `data.padding`, 1)}
                      value={this.convertSpaceValue(selectedElement.data.padding, 1)} />
                    <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Right" /></p></em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={e => this.handleSpaceOnChange(e, `data.padding`, 2)}
                      value={this.convertSpaceValue(selectedElement.data.padding, 2)} />
                    <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Bottom" /></p></em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={e => this.handleSpaceOnChange(e, `data.padding`, 3)}
                      value={this.convertSpaceValue(selectedElement.data.padding, 3)} />
                    <em><p style={{ textAlign: 'center' }} className="text-muted"><SystemLabel name="Left" /></p></em>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          ) : null}

          <hr />
          <EditorSlider
            value={
              selectedElement.data && selectedElement.data.titleWidth
                ? selectedElement.data.titleWidth
                : 0}
            defaultValue={0}
            unitChange={() => null}
            onChange={this.handleChange}
            units={["%"]}
            activeUnit={"%"}
            steps={1}
            min={1}
            max={100}
            path={"data.titleWidth"}
            label="TitleColumnWidth"
          />
          <hr />
          <EditorSlider
            value={
              selectedElement.data && selectedElement.data.inputWidth
                ? selectedElement.data.inputWidth
                : 0}
            defaultValue={0}
            unitChange={() => null}
            onChange={this.handleChange}
            units={["%"]}
            activeUnit={"%"}
            steps={1}
            min={1}
            max={100}
            path={"data.inputWidth"}
            label="FieldColumnWidth"
          />
          <hr />
          <EditorSlider
            value={
              selectedElement.data && selectedElement.data.innerWidth
                ? selectedElement.data.innerWidth
                : 0}
            defaultValue={0}
            unitChange={() => null}
            onChange={this.handleChange}
            units={["%"]}
            activeUnit={"%"}
            steps={1}
            min={1}
            max={100}
            path={"data.innerWidth"}
            label="InnerWidth"
          />
        </ListExpansion>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    selectedElement: state.form.selectedElement
  };
}

export default connect(mapStateToProps)(InvoiceFieldSettings);
